import apiClient from './apiClient';

export type LandingTryoutStatus = 'upcoming' | 'past';

export interface LandingTryoutClub {
  name: string;
  logo_url: string;
}

export interface LandingTryoutCategory {
  name_es: string;
  name_en: string;
  accreditation: string;
  event_time: string;
}

export interface LandingTryout {
  id: string;
  status: LandingTryoutStatus;
  title: string;
  subtitle?: string | null;
  location?: string | null;
  venue?: string | null;
  address?: string | null;
  event_date?: string | null;
  spots?: number | null;
  price?: number | null;
  currency: string;
  buy_link?: string | null;
  promo_image_url?: string | null;
  video_id?: string | null;
  participants?: number | null;
  selected?: number | null;
  clubs: LandingTryoutClub[];
  categories: LandingTryoutCategory[];
  includes_es: string[];
  includes_en: string[];
  highlights_es: string[];
  highlights_en: string[];
  description_es?: string | null;
  description_en?: string | null;
  sort_order: number;
  is_active: boolean;
}

export interface LandingPartner {
  id: string;
  name: string;
  country: string;
  logo_url: string;
  link?: string | null;
  sort_order: number;
  is_active: boolean;
}

export interface LandingPressQuote {
  id: string;
  quote_es: string;
  quote_en: string;
  source?: string | null;
  link?: string | null;
  sort_order: number;
}

export interface LandingStat {
  id: string;
  key: string;
  icon: string;
  value: number;
  suffix: string;
  label_es?: string | null;
  label_en?: string | null;
  sort_order: number;
}

export interface LandingTestimonialStats {
  pace: number;
  shooting: number;
  passing: number;
  dribbling: number;
}

export interface LandingTestimonial {
  id: string;
  name: string;
  team: string;
  country: string;
  rating: number;
  achievement_es: string;
  achievement_en: string;
  quote_es: string;
  quote_en: string;
  stats: LandingTestimonialStats;
  photo_url?: string | null;
  sort_order: number;
}

export interface LandingSnapshot {
  tryouts: {
    upcoming: LandingTryout[];
    past: LandingTryout[];
  };
  partners: LandingPartner[];
  press_quotes: LandingPressQuote[];
  stats: LandingStat[];
  testimonials: LandingTestimonial[];
  content_blocks: Record<string, { es: string; en: string }>;
}

const DEFAULT_SLUG = 'btalentstar';

export const landingApiService = {
  async getSnapshot(slug?: string): Promise<LandingSnapshot> {
    const { data } = await apiClient.get<LandingSnapshot>(
      `/public/landing/${slug || DEFAULT_SLUG}`,
      { skipAuth: true },
    );
    return data;
  },
};

export default landingApiService;
